var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgStriimAi = function SvgStriimAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 22",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.594 18.447a2.5 2.5 0 012.5 2.5 2.5 2.5 0 012.5-2.5 2.5 2.5 0 01-2.5-2.5 2.5 2.5 0 01-2.5 2.5zm0-15a2.5 2.5 0 012.5 2.5 2.5 2.5 0 012.5-2.5 2.5 2.5 0 01-2.5-2.5 2.5 2.5 0 01-2.5 2.5zm-6.094 15a7.5 7.5 0 017.5-7.5 7.5 7.5 0 01-7.5-7.5 7.5 7.5 0 01-7.5 7.5 7.5 7.5 0 017.5 7.5z",
    fill: "#6E7D8C",
    stroke: "#6E7D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgStriimAi;